// src/services/mappers/mapSixesResponse.ts

import type {
  SixWithIcon,
  SixesCatalogApiResponse,
} from "@/types/six/SixDTOs";

/**
 * Maps the API response (which includes metadata like user/org)
 * into a simplified structure for UI components.
 *
 * Adds a placeholder `icon` property for each SIX.
 */
export function mapSixesResponse(apiResponse: SixesCatalogApiResponse): SixWithIcon[] {
  const sixesWithIcons: SixWithIcon[] = (apiResponse.sixes).map((six) => ({
    ...six,
    icon: "/tableIcon.svg",
  }));

  return sixesWithIcons;
}
